export const csvData = [
    ["Box ID", "Weight", "Tracking Number", "Box Code"],
    ["1", "123", "1234567890", "JD014600009296265757"]
]

export const csvFBA = [
    ["Box ID",  "Order Number",     "Tracking Number",  "Shipping Carrier", "Original Carrier", "Tracking Url",                             "Overwrite"],
    ["1",       "AB-12345-12345",   "1234567890",       "UPS",             "DHL Express",    "https://examplate.com?number=1234567890",  "yes"]
]